import React from "react";
import { Utils } from '../utils/Utils';
import { COURSE, COURSE_API } from "../utils/Req";
import { setUserStorage } from '../server/commonFun';

import '../static/css/setting.scss'

export default class ExchangeClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            exchange_value: "",
            tips: ""
        };
        this.putaoid = Utils.getCookie("putaoid");
        this.token = encodeURIComponent(Utils.getCookie("token"));
    }

    componentDidMount() {
        // 获取用户信息
        const that = this;

        fetch(
            `${COURSE_API.user}?putaoid=${that.putaoid}&token=${that.token}&from=pc`,
            { method: "GET" }
        )
            .then(res => res.json())
            .then(data => {
                if (data.code === 200) {
                    this.setState({
                        age: data.age,//年龄
                        gender: data.gender,//性别 1女 0男
                        eng_name: data.eng_name,//姓名
                        photo: data.photo,//头像
                        level: data.course_position.level,
                        phoneNum: data.phoneNum,
                        rewards_num: data.rewards_num,
                        cid: `${data.course_position.level}_${data.course_position.unit}_${data.course_position.lesson
                            }`,
                        learned: data.learned,
                        remaining: data.remaining,
                        pauseButton: data.pauseButton,
                    }, () => {
                        setUserStorage(data);
                    });
                } else if (data.code === 499) {
                    window.location = `${window.location.pathname}${window.location.search}#/login`;
                }
            });
    }

    handleChangeValue(e) {
        this.setState({
            exchange_value: e.target.value || ""
        });
    }

    handleExchange() {
        const that = this;
        const { exchange_value } = this.state;
        if (exchange_value && exchange_value.length) {
            fetch(new Request(`${COURSE_API.activity_usecode}?putaoid=${that.putaoid}&token=${that.token}&conversionCode=${exchange_value}&from=pc`, {
                method: "GET"
            }))
                .then(function (response) {
                    return response.json();
                })
                .then(function (res) {
                    if (res && res.code === 200 && res.data && res.data.lessonNum) {
                        that.setState({
                            tips: `<span style="color: #28c86e">您已成功兑换 ${res.data.lessonNum} 节</span>`
                        });
                    } else {
                        that.setState({
                            exchange_value: "",
                            tips: res && res.msg ? res.msg : `请输入兑换码不对哦，请核对下再试试吧～`
                        });
                    }
                });
        } else {
            that.setState({
                tips: `请输入兑换码～`
            });
        }

        setTimeout(() => {
            that.setState({
                tips: ""
            });
        }, 5000);
    }

    handleGoBack() {
        window.history.back();
        // window.location = `${window.location.pathname}${window.location.search}#/`;
    }

    render() {
        const that = this;
        const { tips, exchange_value } = this.state
        return (
            <div className="settingbox">
                <div className="setting-container">
                    <div className="go-back" onClick={() => that.handleGoBack()} />
                    <p className="setting-title">兑换节数</p>
                    <div className="exchange-box">
                        <input type="text" className="exchange-inp" placeholder="输入兑换码" value={exchange_value} onChange={(e) => { this.handleChangeValue(e) }} />
                        <div className="exchage-error" dangerouslySetInnerHTML={{ __html: tips }} />
                        <div className="exchange-btn" onClick={() => { this.handleExchange() }}>兑换</div>
                        <div className="exchage-intro">
                            <h2><span>兑换说明</span></h2>
                            <ol className="copyright">
                                <li>
                                    <h3>如何获得兑换码？</h3>
                                    <p>步步ABC服务号，以及各大平台将不定期发放兑换码，敬请关注。</p>
                                </li>
                                <li>
                                    <h3>为什么兑换失败？</h3>
                                    <p>常见造成兑换失败的问题一般有：</p>
                                    <ul>
                                        <li>• 活动已过期，过了活动期兑换码会自动失效哦~</li>
                                        <li>• 已兑换过了，多数活动每人限参加1次，已兑换过不能重复兑换哦~</li>
                                        <li>• 遇到了网络或服务器问题，换个时间重试一下吧~</li>
                                    </ul>
                                </li>
                            </ol>
                            <p>如果您遇到其他异常问题，请随时联系我们：<strong>400-827-9800</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/route/ExchangeClass.js